import axios from "axios";

// Maps backend `/persons/top/N` shape ({ name: { count, articles } }) into
// the weighted Entity shape that EntityCloud renders.
// Weight buckets: 3 = brand-red big, 2 = medium dark, 1 = chip, 0 = small grey.
const bucketByCount = (count, maxCount) => {
  if (maxCount <= 0) return 1;
  const ratio = count / maxCount;
  if (ratio >= 0.75) return 3;
  if (ratio >= 0.45) return 2;
  if (ratio >= 0.2) return 1;
  return 0;
};

export const fetchTopEntities = async (limit = 14) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/persons/top/${limit}`
    );
    const list = Object.entries(res.data || {});
    if (list.length === 0) return [];
    const maxCount = Math.max(...list.map(([, d]) => d.count || 0));
    return list
      .sort(([, a], [, b]) => b.count - a.count)
      .map(([name, data]) => ({
        name,
        weight: bucketByCount(data.count || 0, maxCount),
        count: data.count || 0,
        articles: data.articles || [],
      }));
  } catch (err) {
    console.error("Failed to fetch top entities:", err);
    return [];
  }
};

export const fetchCategoryEntities = async (category, limit = 14) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/persons/category/${encodeURIComponent(
        category
      )}`
    );
    const list = Object.entries(res.data || {});
    if (list.length === 0) return [];
    const sliced = list
      .sort(([, a], [, b]) => b.count - a.count)
      .slice(0, limit);
    const maxCount = Math.max(...sliced.map(([, d]) => d.count || 0));
    return sliced.map(([name, data]) => ({
      name,
      weight: bucketByCount(data.count || 0, maxCount),
      count: data.count || 0,
      articles: data.articles || [],
    }));
  } catch (err) {
    console.error("Failed to fetch category entities:", err);
    return [];
  }
};
